'use strict';

import dot from "dot";
import ListingBase from "../../../_scripts/listingBase";
import ListingFilter from "../../molecules/listing-filter/listing-filter";
import LoadingIcon from "../../atoms/loading-icon/loading-icon";
import SmartSearchbar from '../../molecules/smart-searchbar/smart-searchbar';

export default class FilmTvListing extends ListingBase {
  constructor($selector, selfInit = true, config) {
    let $filters = $(".film-tv-listing__filters", $selector);
    let $pagination = $(".film-tv-listing__pagination", $selector);

    let dataModel = {
      page: 1,
      keyword: "",
      type: "",
      media: "",
      genre: "",
      language: "",
      startyear: "",
      endyear: "",
      award: "",
      itemsPerPage: 9
    };

    let parametersModel = {
      page: 1,
      keyword: "",
      type: "",
      media: "",
      genre: "",
      language: "",
      startyear: "",
      endyear: "",
      award: "",
      itemsPerPage: 9
    }; 

    super($pagination, dataModel, parametersModel);

    new ListingFilter($filters);

    // Setup basic
    this.$selector = $selector;
    this.$template = $("#filmTvListingTemplate").html();
    this.$content = $(".film-tv-listing__content", $selector);
    this.$list = $(".film-tv-listing__list", $selector);
    this.endpoint = $selector.data("endpoint");
    this.$loadingIcon = new LoadingIcon($(".loading-icon", $selector));

    this.startYearFieldname = "startyear";
    this.endYearFieldname = "endyear";
    this.startYear = "";
    this.endYear = "";

    //Setup smart searchbar
    this.smartSearchbar = new SmartSearchbar($('.smart-searchbar', $selector), true, config);

    // Define fields
    let $search = $("#keyword", $filters);

    // get all parameters value
    //let queries = this.getUrlQueries();

    // Get all fields
    const allFields = this.getAllFields($selector);

    // Generate parameters using fields
    this.parameters = this.getParameters(allFields);
    this.parameters.page = (this.queries["page"]) ? decodeURIComponent(this.queries["page"]) : 1;

    //Setup listeners
    this.setupSearchbar("keyword");
    this._setupFilmCardListeners();
    this._setupSearchResultListener($search);
    this._setupListingListeners($search, $filters);

    //Setup dataLayer
    this.dataLayerModel = {
      event: "historyChange-v2",
      directoryKeyword: "",
      directoryMainFilter: "all",
      directoryMediaType: "all",
      directoryGenre: "all",
      directoryLanguage: "all",
      directoryYearType: "all",
      directoryStartYear: "all",
      directoryEndYear: "all",
      directoryAward: "all",
      directoryFilters: "all",
      directoryURL: ""
    }

    //Setup updateData action
    this._updateData = () => {
      this.$content.addClass("content-updating");
      this.$loadingIcon.playAnimation();
      this._pushDataLayer();

      let scrollPos = $(window).scrollTop();
      if (scrollPos >= this.$content.offset().top) {
        $("html, body").animate({
          scrollTop: this.$content.offset().top - 230,
        });
      }

      let callback = (res) => {
        this._renderTemplate(res);
        if (res.items.length == 0) {
          this.$pagination.hide();
        } else {
          this.$pagination.show();
          this._renderPagination(res.totalpages);
        }
      };

      this.updateData({
        endpoint: this.endpoint,
        data: this.parameters,
        callback: callback,
      });
    };

    //Setup window.onpopstate
    window.onpopstate = (e) => {
      for (let key in e.state) {
        this.parameters[key] = e.state[key];
      }
      this._updateView($filters);

      this._updateData();
    };
    
    // Make call upon page load
    this._updateData();
    this.updateURL();

  }

  _renderTemplate(data) {
    let dotTemplate = dot.template(this.$template)(data.items);

    this.$list.html(dotTemplate);

    this._updateSummary(data.totalItems);
    this._renderCategoryTabCount(data.categorycount);

    setTimeout(() => {
      this.$content.addClass("content-loaded");
      this.$content.removeClass("content-updating");
      this.$loadingIcon.restartFrame();
    }, 250);
  }

  _renderPagination(totalpages) {
    let callback = () => {
      this.$pagination.find("a").map((i, ele) => {
        let $this = $(ele);

        $this.on("click", (e) => {
          e.preventDefault();
          this.data.page = $this.data("page");
          this.parameters.page = this.data.page;

          this._updateData();
          this.updateURL();
        });
      });
    };

    this.pagination.update(this.parameters.page, totalpages, callback);
  }

  _renderCategoryTabCount(categorycount) {
    const countHtml = '<span class="category-count"></span>';
    
    //Display the count for category tabs
    $.each(categorycount, (key, count) => {
      let $label = $('label[for="' + key + '"]');

      if ($label.find('.category-count').length === 0) {
        $label.append(countHtml);
      }

      $('.category-count', $label).html('(' + count + ')');
    })
  }

  getFilterValues() {
    return `${
      this.dataLayerModel.directoryKeyword ? this.dataLayerModel.directoryKeyword + "|" : "|"
    }${
      this.dataLayerModel.directoryMainFilter ? this.dataLayerModel.directoryMainFilter + "|" : ""
    }${
      this.dataLayerModel.directoryMediaType ? this.dataLayerModel.directoryMediaType + "|" : ""
    }${
      this.dataLayerModel.directoryGenre ? this.dataLayerModel.directoryGenre + "|" : ""
    }${
      this.dataLayerModel.directoryLanguage ? this.dataLayerModel.directoryLanguage + "|" : ""
    }${
      this.dataLayerModel.directoryYearType ? this.dataLayerModel.directoryYearType + "|" : ""
    }${
      this.dataLayerModel.directoryStartYear ? this.dataLayerModel.directoryStartYear + "|" : ""
    }${
      this.dataLayerModel.directoryEndYear ? this.dataLayerModel.directoryEndYear + "|" : ""
    }${
      this.dataLayerModel.directoryAward ? this.dataLayerModel.directoryAward + "|" : ""
    }${
      this.dataLayerModel.directoryURL ? this.dataLayerModel.directoryURL + "|" : ""
    }`;
  }

  _pushDataLayer() {
    window.dataLayer = window.dataLayer || [];
    this.dataLayerModel.directoryKeyword = `${this.parameters.keyword ? this.parameters.keyword : ""}`;
    this.dataLayerModel.directoryMainFilter = `${this.parameters.type ? this.parameters.type : ""}`;
    this.dataLayerModel.directoryMediaType = `${this.parameters.media ? this.parameters.media : ""}`;
    this.dataLayerModel.directoryGenre = `${this.parameters.genre ? this.parameters.genre : ""}`;
    this.dataLayerModel.directoryLanguage = `${this.parameters.language ? this.parameters.language : ""}`;
    this.dataLayerModel.directoryYearType = `${this.parameters["year-type"] ? this.parameters["year-type"] : ""}`;
    if (this.parameters["year-type"] != "all") {
      this.dataLayerModel.directoryStartYear = `${this.parameters.startyear ? this.parameters.startyear : "all"}`;
      this.dataLayerModel.directoryEndYear = `${this.parameters.endyear ? this.parameters.endyear : "all"}`;
    } else {
      this.dataLayerModel.directoryStartYear = "all";
      this.dataLayerModel.directoryEndYear = "all";
    }
    
    this.dataLayerModel.directoryAward = `${this.parameters.award ? this.parameters.award : "all"}`;

    this.dataLayerModel.directoryFilters = this.getFilterValues() ? this.getFilterValues() : "";
    this.dataLayerModel.directoryURL = '';

    //Set dataLayer 
    dataLayer.push(this.dataLayerModel);
  }

  _setupFilmCardListeners() {
    this.$selector.on('click', '.film-tv-card a', (e) => {
      e.preventDefault();

      const dataUrl = $(e.currentTarget).closest("a").attr("href");
      const dataTarget = $(e.currentTarget).closest("a").attr("target");

      this.dataLayerModel.directoryURL = dataUrl;
      dataLayer.push(this.dataLayerModel);

      if (dataTarget == "_blank") {
        window.open(dataUrl, dataTarget);
      } else {
        window.open(dataUrl, "_self");
      }
    });
  }

  _setupSearchResultListener($search) {
    this.$selector.on('click', '.search-filters__suggestions a', (e) => {
      e.preventDefault();
      const dataUrl = $(e.currentTarget).closest("a").attr("href");
      const dataTarget = $(e.currentTarget).closest("a").attr("target");

      this.dataLayerModel.directoryKeyword = $search.val();
      this.dataLayerModel.directoryURL = dataUrl;
      dataLayer.push(this.dataLayerModel);
      
      if (dataTarget == "_blank") {
        window.open(dataUrl, dataTarget);
      } else {
        window.open(dataUrl, "_self");
      }
    });
  }

  _setupListingListeners($search, $filters) {
    //Submit button listener
    this.$selector.on('click', '.btn-search', (e) => {
      e.preventDefault();
      $('.smart-searchbar', this.$selector).removeClass('active');
      this.parameters.keyword = $search.val();
      this.data.keyword = $search.val();
      this.parameters.page = 1;
      this.data.page = 1;
      this._updateData();
      this.updateURL();
    });

    $('.smart-searchbar .search-filters__input', this.$selector).on('keyup', e => {
      e.preventDefault();
      if (e.keyCode == 13 || e.which == 13) {
        this.parameters.keyword = $search.val();
        this.data.keyword = $search.val();
        this.parameters.page = 1;
        this.data.page = 1;
        this._updateData();
        this.updateURL();
      }
    });

    //Reset button listener
    $('.listing-filter__reset-btn', $filters).on('click', (e)=> {
      this._handleReset();
    });

    //Radio listener for category tabs
    $('.radio-buttons', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='radio']:eq(0)`).attr('name');
      this.setupRadioButton(fieldName);

      $(`input[name="${fieldName}"]`).map((i, ele) => {
        let $this = $(ele);
        $this.on('change', e => {
          if ($this.prop('checked') == true) {
            this.parameters[fieldName] = $this.val();
            this.data[fieldName] = $this.val();
            this.parameters.page = 1;
            this.data.page = 1;
            this._updateData();
            this.updateURL();
          } 
        });
      });
    });

    //Filter listener
    $('select', $filters).map((i, ele) => {
      const fieldName = $(ele).attr('name');
      this.setupSelect(fieldName);

      $(ele).on('change', (e) => {
        this.parameters[fieldName] = $(ele).val();
        this.data[fieldName] = $(ele).val();
        this.parameters.page = 1;
        this.data.page = 1;
        this._updateData();
        this.updateURL();
      });
    });

    //-- Custom year filter listeners --
    //Radio button to select year type
    $('.custom-year-filter__options', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='radio']:eq(0)`).attr('name');
      this.setupRadioButton(fieldName);
      $(`input[name="${fieldName}"]:checked`, $(ele)).trigger('click.customyeartype');

      $(`input[name="${fieldName}"]`, $filters).map((i, ele) => {
        let $this = $(ele);
        $this.on('change', e => {
          if ($this.prop('checked') == true) {
            this.parameters[fieldName] = $this.val();
            this.data[fieldName] = $this.val();
            this.updateURL();

            if($this.val() == 'all') {
              this.parameters.page = 1;
              this.data.page = 1;
              this._updateData();
            }
          }
        });
      });
    });

    //let $presetYearRangeList = $('.custom-year-filter__preset-range', $filters);
    $('.custom-year-filter__preset-range', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='radio']:eq(0)`).attr('name');
      $(`input[name="${fieldName}"]`, $filters).map((i, inputEle) => {
        $(inputEle).on('change', e => {
          //Remove error message
          const $yearFilterWrapper = $('.custom-year-filter__filter', $filters);
          $('.custom-year-filter__year-range', $yearFilterWrapper).find('.error-msg').remove();

          if ($(inputEle).prop('checked') == true) {
            let yearArr = $(inputEle).val().split('-');
            this.parameters[this.startYearFieldname] = yearArr[0];
            this.data[this.startYearFieldname] = yearArr[0];
            this.parameters[this.endYearFieldname] = yearArr[1]; 
            this.data[this.endYearFieldname] = yearArr[1];
            this.parameters.page = 1;
            this.data.page = 1;
            this._updateData();
            this.updateURL();
          }
        });
      });
    });

    if (this.parameters['year-type'] != 'all' && this.parameters['year-type'] != '') {
      //Update dropdown label for the selected year / year range
      if (this.parameters['year-type'] == 'single') {
        this.parameters[this.startYearFieldname] = this.queries[this.startYearFieldname] ? this.queries[this.startYearFieldname] : "";
        this.parameters[this.endYearFieldname] = this.queries[this.endYearFieldname] ? this.queries[this.endYearFieldname] : "";
        if ((typeof this.parameters[this.startYearFieldname] != 'undefined' || this.parameters[this.startYearFieldname] != 'undefined') && (typeof this.parameters[this.endYearFieldname] != 'undefined' || this.parameters[this.endYearFieldname] != 'undefined')) {
          let inputValue = this.parameters[this.startYearFieldname] + '-' + this.parameters[this.endYearFieldname];
          $(`input[value="${inputValue}"]`, $filters).prop('checked', true);
          $(`input[value="${inputValue}"]`, $filters).trigger('click.customyearoption');
        }
      } else {
        this.parameters[this.startYearFieldname] = this.queries[this.startYearFieldname] ? this.queries[this.startYearFieldname] : "";
        this.parameters[this.endYearFieldname] = this.queries[this.endYearFieldname] ? this.queries[this.endYearFieldname] : "";
        //this.startYear = this.parameters[this.startYearFieldname];
        //this.endYear = this.parameters[this.endYearFieldname];
        let labelStr = "";
        labelStr = this.parameters[this.startYearFieldname] ? `${this.parameters[this.startYearFieldname]}-` : '*-';
        labelStr += this.parameters[this.endYearFieldname] ? this.parameters[this.endYearFieldname] : '*';
        
        //let $startYearField = $(`input[name="${this.startYearFieldname}"]`, $filters);
        $(`input[name="${this.startYearFieldname}"]`, $filters).val(this.parameters[this.startYearFieldname]);

        //let $endYearField = $(`input[name="${this.endYearFieldname}"]`, $filters);
        $(`input[name="${this.endYearFieldname}"]`, $filters).val(this.parameters[this.endYearFieldname]);

        if (this.parameters[this.startYearFieldname] != "" && this.parameters[this.endYearFieldname] != "") {
          $(`input[name="${this.startYearFieldname}"]`, $filters).parents('.custom-year-filter__dropdown').find('.custom-trigger .label').text(labelStr);
        }
      }
    }
    
    //Year range text filter
    this.$rangeYearFilter = $('.custom-year-filter__year-range', $filters);
    $('input[type="text"]', this.$rangeYearFilter).map((i, ele) => {
      $(ele).on('keydown', e => {
        // Allow: backspace, delete, tab, escape, and enter
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
          // Allow: Ctrl/cmd+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+C
          (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: Ctrl/cmd+X
          (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
  
        // Check if the input already has 4 digits
        if ($(ele).val().length >= 4 && !(e.keyCode === 8 || e.keyCode === 46)) {
          // Prevent input if it's not a backspace or delete
          e.preventDefault();
        }
      });
    });
    let keyupTimeout;
    let $startYearInput = $(`input[name="${this.startYearFieldname}"]`, $filters);
    let $endYearInput = $(`input[name="${this.endYearFieldname}"]`, $filters);
    this.startYear = $startYearInput.val();
    this.endYear = $endYearInput.val();
    $startYearInput.on('keyup', e => {
      e.preventDefault();
      clearTimeout(keyupTimeout);

      keyupTimeout = setTimeout(() => {
        this.startYear = $startYearInput.val();
      
        const $yearFilterWrapper = $('.custom-year-filter__filter', $filters);
        const $yearRangeWrapper = $('.custom-year-filter__year-range', $yearFilterWrapper);
        const $errorMsg = $yearRangeWrapper.find('.error-msg');

        //Remove checked status for other year options
        $('.radio', $yearFilterWrapper).map((i, ele) => {
          $(ele).prop('checked', false);
        });

        //If only 1 year field is filled in, don't need to validate or call API
        if (this.endYear != "") {
          if (this.validateYears(this.startYear, this.endYear)) {
            //Remove error message
            $errorMsg.remove();
  
            let labelStr = this.startYear ? `${this.startYear}-` : '*-';
            labelStr += this.endYear ? this.endYear : '*';
  
            $startYearInput.parents('.custom-year-filter__dropdown').find('.custom-trigger .label').text(labelStr);
            
            // Call the update method only if validation passes
            this._updateYearRange();
          } else {
            if (!$errorMsg.length) {
              $yearRangeWrapper.append('<p class="error-msg">Please enter a valid year range with "To" year greater than "From" year.</p>');
              $yearRangeWrapper.addClass('has-error');
            }
          }
        }
        //this._updateYearRange(this.startYearFieldname, this.startYear);
      }, 300);
    });

    $endYearInput.on('keyup', e => {
      e.preventDefault();
      clearTimeout(keyupTimeout);

      keyupTimeout = setTimeout(() => {
        this.endYear = $endYearInput.val();

        const $yearFilterWrapper = $('.custom-year-filter__filter', $filters);
        const $yearRangeWrapper = $('.custom-year-filter__year-range', $yearFilterWrapper);
        const $errorMsg = $yearRangeWrapper.find('.error-msg');

        //Remove checked status for other year options
        $('.radio', $yearFilterWrapper).map((i, ele) => {
          $(ele).prop('checked', false);
        });

        if (this.startYear != "") {
          if (this.validateYears(this.startYear, this.endYear)) {
            //Remove error message
            $errorMsg.remove();
  
            let labelStr = this.startYear ? `${this.startYear}-` : '*-';
            labelStr += this.endYear ? this.endYear : '*';
  
            $endYearInput.parents('.custom-year-filter__dropdown').find('.custom-trigger .label').text(labelStr);
            // Call the update method only if validation passes
            this._updateYearRange();
          } else {
            if (!$errorMsg.length) {
              $yearRangeWrapper.append('<p class="error-msg">Please enter a valid year range with "To" year greater than "From" year.</p>');
              $yearRangeWrapper.addClass('has-error');
            }
          }
        }
      }, 300);
    });

    //Checkbox listener
    $('.checkboxes', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='checkbox']:eq(0)`).attr('name');

      //Configure the checkbox display on load based on URL queries
      this.parameters[fieldName] = (this.queries[fieldName]) ? this.queries[fieldName] : "";
      if ((typeof this.parameters[fieldName] != 'undefined' || this.parameters[fieldName] != 'undefined')) {
        let inputValue = this.parameters[fieldName];

        $(`input[value="${inputValue}"]`, $filters).prop('checked', true);
      }

      $(`input[name="${fieldName}"]`).map((i, inputEle) => {
        let $this = $(inputEle);
        $this.on('change', e => {
          if ($this.prop('checked') == true) {
            this.parameters[fieldName] = $this.val();
          } else {
            this.parameters[fieldName] = "";
          }
  
          this.data[fieldName] = this.parameters[fieldName];
          this.parameters.page = 1;
          this.data.page = 1;
          this._updateData();
          this.updateURL();
        });
      });
    });

    //Scrollable listeners for category tabs
    let $scrollableContainer = $('.listing-filter__category-tabs');
    $('.radio-label', $scrollableContainer).map((i, ele) => {
      $(ele).on('click', () => {
        this.scrollToCategory($(ele));
      });
    });
    
    let $radioButtons = $scrollableContainer.find('.radio--pill');
    $('.listing-filter__category-next-btn', '.listing-filter__category-tabs-wrapper').on('click', () => {
      let $currentChecked = $radioButtons.filter(':checked');
      let $nextRadio = $currentChecked.next('label').next('.radio--pill');
      if ($nextRadio.length) {
        $nextRadio.prop('checked', true);
        $nextRadio.trigger('change');
        this.scrollToCategory($('label[for="' + $nextRadio.attr('id') + '"]'));
      }
    });

    $('.listing-filter__category-prev-btn', '.listing-filter__category-tabs-wrapper').on('click', () => {
      let $currentChecked = $radioButtons.filter(':checked');
      let $prevRadio = $currentChecked.prev('label').prev('.radio--pill');
      if ($prevRadio.length) {
        $prevRadio.prop('checked', true);
        $prevRadio.trigger('change');
        this.scrollToCategory($('label[for="' + $prevRadio.attr('id') + '"]'));
      }
    });

    $radioButtons.map((i, ele) => {
      if ($(ele).prop('checked') == true) {
        if ($(ele).data('has-filters') !== undefined) {
          $('.listing-filter__filters-wrapper', this.$selector).fadeIn(300);
        } else {
          $('.listing-filter__filters-wrapper').fadeOut(300);
        }
      }
      $(ele).on('click', () => {
        if ($(ele).data('has-filters') !== undefined) {
          // Show the .listing-filter__filters-wrapper
          $('.listing-filter__filters-wrapper', this.$selector).fadeIn(300);
        } else {
          // Hide the .listing-filter__filters-wrapper
          $('.listing-filter__filters-wrapper').fadeOut(300);
        }
      });
    });
  }

  validateYears(startYear, endYear) {
    // Check if both years are numbers and end year is greater than or equal to start year
    return /^\d{4}$/.test(startYear) && /^\d{4}$/.test(endYear) && parseInt(endYear, 10) >= parseInt(startYear, 10);
  }

  scrollToCategory($label) {
    //let $scrollableContainer = $('.listing-filter__category-tabs');

    let $scrollableContainer = $('.listing-filter__category-tabs');
    let labelOffset = $label.position().left + $scrollableContainer.scrollLeft();
    let labelCenter = $label.outerWidth() / 2;
    let containerCenter = $scrollableContainer.width() / 2;
    let scrollPosition = labelOffset - containerCenter + labelCenter;

    $scrollableContainer.animate({
      scrollLeft: scrollPosition
    }, 500); 
  }

  _updateView($filters) {
    this.updateSearchbarView("keyword");

    $('select', $filters).map((i, ele) => {
      const fieldName = $(ele).attr('name');
      this.updateSelectView(fieldName);
    });

    $('.radio-buttons', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='radio']:eq(0)`).attr('name');
      this.updateRadioButtonView(fieldName);
    });

    let $scrollableContainer = $('.listing-filter__category-tabs');
    let $radioButtons = $scrollableContainer.find('.radio--pill');
    $radioButtons.map((i, ele) => {
      if ($(ele).prop('checked') == true) {
        if ($(ele).data('has-filters') !== undefined) {
          $('.listing-filter__filters-wrapper', this.$selector).fadeIn(300);
        } else {
          $('.listing-filter__filters-wrapper').fadeOut(300);
        }
      }
    });

    $('.custom-year-filter__options', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='radio']:eq(0)`).attr('name');
      this.updateRadioButtonView(fieldName);

      $(`input[name="${fieldName}"]:checked`, $(ele)).trigger('click.customyeartype');
    });

    //this.updateRadioButtonView(this.singleYearFieldName, 'year', false);

    if (this.parameters['year-type'] == 'single') {
      let inputValue = this.parameters[this.startYearFieldname] + '-' + this.parameters[this.endYearFieldname];
      $(`input[value="${inputValue}"]`, $filters).prop('checked', true);
      $(`input[value="${inputValue}"]`, $filters).trigger('click.customyearoption');
    } else if (this.parameters['year-type'] == 'range') {
      let $yearRangeFilterWrapper = $('.custom-year-filter__year-range', $filters);
      let $startYearInput = $(`input[name="${this.startYearFieldname}"]`, $yearRangeFilterWrapper);
      let $endYearInput = $(`input[name="${this.endYearFieldname}"]`, $yearRangeFilterWrapper);

      if ((typeof this.parameters[this.startYearFieldname] != 'undefined' && this.parameters[this.startYearFieldname] != 'undefined')) {
        $startYearInput.val(this.parameters[this.startYearFieldname]);
      }

      if ((typeof this.parameters[this.endYearFieldname] != 'undefined' && this.parameters[this.endYearFieldname] != 'undefined')) {
        $endYearInput.val(this.parameters[this.endYearFieldname]);
      } 

      this.startYear = this.parameters[this.startYearFieldname];
      this.endYear = this.parameters[this.endYearFieldname];
      let labelStr = this.startYear ? `${this.startYear}-` : '*-';
      labelStr += this.endYear ? this.endYear : '*';

      $endYearInput.parents('.custom-year-filter__dropdown').find('.custom-trigger .label').text(labelStr);
    }

    $('.checkboxes', $filters).map((i, ele) => {
      const fieldName = $(ele).find(`input[type='checkbox']:eq(0)`).attr('name');

      //Configure the checkbox display on load based on URL queries
      let inputValue = this.parameters[fieldName];
      
      if ((typeof this.parameters[fieldName] != 'undefined' || this.parameters[fieldName] != 'undefined')) {
        $(`input[value="${inputValue}"]`, $filters).prop('checked', true);
      }

      $(`input[name="${fieldName}"]`).map((i, inputEle) => {
        if ($(inputEle).val() == inputValue) {
          $(inputEle).prop('checked', true);
        } else {
          $(inputEle).prop('checked', false);
        }
      });
    });
  }

  _updateSummary(totalItems) {
    const $listingSummary = $(".film-tv-listing__summary");

    if (parseInt(totalItems) === 0) {
      $(".page", $listingSummary).text(`0`);
      $(".separator", $listingSummary).hide();
      $(".total", $listingSummary).hide();
    }

    if (parseInt(totalItems) !== 0) {
      $(".separator", $listingSummary).show();
      $(".total", $listingSummary).show();
      const start = (this.parameters.page - 1) * this.data.itemsPerPage + 1;
      const end =
        this.parameters.page * this.data.itemsPerPage > totalItems
          ? totalItems
          : this.parameters.page * this.data.itemsPerPage;

      $(".page", $listingSummary).text(`${start} - ${end}`);
    }

    $(".total", $listingSummary).text(totalItems);
  }

  _updateYearRange() {
    this.parameters[this.startYearFieldname] = this.startYear;
    this.data[this.startYearFieldname] = this.startYear;
    this.parameters[this.endYearFieldname] = this.endYear;
    this.data[this.endYearFieldname] = this.endYear;
    this.parameters.page = 1;
    this.data.page = 1;
    this._updateData();
    this.updateURL();
  }

  _handleReset() {
    let $filters = $('.listing-filter__filters-wrapper', this.$selector);
    $('select', $filters).map((i, ele) => {
      const fieldName = $(ele).attr('name');
      this.parameters[fieldName] = $(`select[name='${fieldName}'] option:eq(0)`).val();
      this.updateSelectView(fieldName);
    });

    let $yearFilterWrapper = $('.custom-year-filter__filter', $filters);
    $('.radio', $yearFilterWrapper).map((i, ele) => {
      $(ele).prop('checked', false);
    });

    this.startYear = "";
    this.endYear = "";
    let $yearRangeFilterWrapper = $('.custom-year-filter__year-range', $filters);
    $('input[type="text"]', $yearRangeFilterWrapper).map((i, ele) => {
      $(ele).val("");
    });

    $('.custom-year-filter__options', $filters).map((i, ele) => {
      let $firstInputEle = $(ele).find(`input[type='radio']:eq(0)`);
      const fieldName = $firstInputEle.attr('name');
      this.parameters[fieldName] = $firstInputEle.val();
      //this.(fieldName);
      $firstInputEle.prop('checked', true);
      $(`input[name="${fieldName}"]:checked`, $(ele)).trigger('click.customyeartype');

      this.parameters[this.startYearFieldname] = "";
      this.parameters[this.endYearFieldname] = "";
      
    });

    $('.checkbox', $filters).map((i, ele) => {
      const fieldName = $(ele).attr('name');
      this.parameters[fieldName] = "";
      $(ele).prop('checked', false);
    })

    this.parameters.page = 1;
    this.data.page = 1;
    this._updateData();
    this.updateURL();
  }
}
